import { useEffect } from "react";
import {
    BrowserRouter as ReactRouter,
    Switch,
    Route,
    Redirect,
    useLocation
} from "react-router-dom";
import Components from "screens/Components";
import Dashboard from "screens/Dashboard";
import OperatingSchedule from "screens/OperatingSchedule";
import OperatingRegulations from "screens/OperatingRegulations";
import Step1 from "screens/Step1";
import Step2 from "screens/Step2";
import Step3 from "screens/Step3";
import Step4 from "screens/Step4";
import Step5 from "screens/Step5";
import Step6 from "screens/Step6";
import Step7 from "screens/Step7";
import Step8 from "screens/Step8";
import Confirmation from "screens/Confirmation";
import Reason from "screens/Reason";
import Document from "screens/Document";



import DashboardLayout from "./layouts/DashboardLayout";

export function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        setTimeout(window.scrollTo(0, 0), 3000);
    }, [pathname]);

    return null;
}

export default function Router() {
    const routeConfig = [
        {
            path: "/",
            component: <Redirect to="/programare" />,
            isPublic: true,
            exact: true,
        },
        {
            path: "/programare",
            layout: DashboardLayout,
            isPublic: true,
            routes: [
                {
                    path: "/programare",
                    component: Dashboard,
                    exact: true,
                },
                {
                    path: "/programare/operatingschedule",
                    component: OperatingSchedule,
                    exact: true,
                },
                {
                    path: "/programare/operatingregulations",
                    component: OperatingRegulations,
                    exact: true,
                },
                {
                    path: "/programare/step1",
                    component: Step1,
                    exact: true,
                },
                {
                    path: "/programare/step2",
                    component: Step2,
                    exact: true,
                },
                {
                    path: "/programare/step3",
                    component: Step3,
                    exact: true,
                },
                {
                    path: "/programare/step4",
                    component: Step4,
                    exact: true,
                },
                {
                    path: "/programare/step5",
                    component: Step5,
                    exact: true,
                },
                {
                    path: "/programare/step6",
                    component: Step6,
                    exact: true,
                },
                {
                    path: "/programare/step7",
                    component: Step7,
                    exact: true,
                },
                {
                    path: "/programare/step8",
                    component: Step8,
                    exact: true,
                },
                {
                    path: "/programare/confirmation",
                    component: Confirmation,
                    exact: true,
                },
                {
                    path: "/programare/reason",
                    component: Reason,
                    exact: true,
                },
                {
                    path: "/programare/document",
                    component: Document,
                    exact: true,
                },
            ],
        },
        {
            path: "/components",
            component: <Components />,
            exact: true,
            isPublic: true,
        },
    ];
    return (
        <ReactRouter>
            <ScrollToTop />
            <Switch>
                {routeConfig.map((routeItem) =>
                    routeItem?.isPublic ? (
                        <Route
                            path={routeItem.path}
                            exact={routeItem.exact}
                            key={routeItem.path}
                        >
                            {routeItem.layout ? (
                                <routeItem.layout
                                    // eslint-disable-next-line react/no-children-prop
                                    children={
                                        routeItem.routes?.length > 0
                                            ? routeItem.routes.map((route) => (
                                                <Route
                                                    path={route.path}
                                                    exact={route.exact}
                                                    key={route.path}
                                                >
                                                    <route.component />
                                                </Route>
                                            ))
                                            : null
                                    }
                                />
                            ) : (
                                routeItem.component
                            )}
                        </Route>
                    ) : (
                        <AuthenticatedRoute
                            path={routeItem.path}
                            exact={routeItem.exact}
                            key={routeItem.path}
                        >
                            {routeItem.layout ? (
                                <routeItem.layout
                                    // eslint-disable-next-line react/no-children-prop
                                    children={
                                        routeItem.routes?.length > 0
                                            ? routeItem.routes.map((route) => (
                                                <AuthenticatedRoute
                                                    path={route.path}
                                                    exact={route.exact}
                                                    key={route.path}
                                                >
                                                    <route.component />
                                                </AuthenticatedRoute>
                                            ))
                                            : null
                                    }
                                />
                            ) : (
                                routeItem.component
                            )}
                        </AuthenticatedRoute>
                    )
                )}
            </Switch>
        </ReactRouter>
    );
}

// eslint-disable-next-line react/prop-types
const AuthenticatedRoute = ({ children, ...rest }) => {
    const token = localStorage.getItem("token");
    return (
        <Route
            {...rest}
            render={() => (token ? children : <Redirect to="/" />)}
        ></Route>
    );
};
